/**
 * Nur Raster-Bilder werden inline als `<img>` dargestellt (und automatisch
 * per `useBlobUrl` geladen, sobald `TicketDetail` öffnet). SVG zählt fachlich
 * als „Bild", ist aber XML mit potenziellem `<script>` und darf im Browser
 * nicht als aktives Dokument im KMVS-Origin laufen — dieselbe Regel wie in
 * `apps/api/src/document-inline.util.ts` (`darfInlineAngezeigtWerden`) für die
 * Download-Route. Alles andere ist ein reiner Download, den der Nutzer erst
 * per Klick lädt, statt dass „Ticket öffnen" jeden Anhang vorab abruft.
 */
const RASTER_BILD_MIME = new Set([
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/bmp",
]);

export function istRasterBild(mimeType: string | null | undefined): boolean {
  const normalisiert = String(mimeType ?? "").split(";")[0].trim().toLowerCase();
  return RASTER_BILD_MIME.has(normalisiert);
}
